export enum FeatureFlags {
  OutOfStatePlacement = 'outOfStatePlacement',
  MyTools = 'myTools',
  ImplementationPlan = 'implementationPlan',
  DataManagement = 'dataManagement',
  DisputeResolution = 'disputeResolution',
  CorrectiveAction = 'correctiveAction',
  CorrectiveActionRevision = 'correctiveActionRevision',
  ContinuousImprovement = 'continuousImprovement',
  FocusedMonitoring = 'focusedMonitoring',
  DataReviewProtocol = 'dataReviewProtocol',
  ELAA = 'elaa',
  ShowIvrsBanner = 'showIvrsBanner',
  Ivrs = 'ivrs',
  FitCsa = 'fitCsaEnabled',
  IlotReportingExport = 'ilotReportingExport',
  IVRSPhase2 = 'ivrsPhase2',
  Equity = 'equity',
  SigDisPro = 'sigDisPro',
  StateComplaint = 'stateComplaint',
  Mediation = 'mediation',
  DueProcess = 'dueProcess',
  Dhh = 'dhh',
  DueDiligence = 'dueDiligence',
  DataDashboard = 'dataDashboard',
  DhhDataDashboard = 'dhhDataDashboard',
  DisputeResolutionDashboard = 'disputeResolutionDashboard',
  EnableStickyNoteForPortalUsers = 'enableStickyNoteForPortalUsers',
  PendingLearnersMerge = 'pendingLearnersMerge',
  DrpStep1A = 'drpStep1A',
  MedicaidReporting = 'medicaidReporting',
  BackgroundReportProcessing = 'backgroundReportProcessing',
  ProgressMonitoringRevision = 'progressMonitoringRevision',
  EquityReviewRevision = 'equityReviewRevision',
  Eipses = 'eipses',
  ProgressMonitoringReport = 'progressMonitoringReport',
  ExitDashboard = 'exitDashboard',
  FMCAPChanges = 'fmcapChanges',
  MeetingIepAddendum = 'meetingIepAddendum',
  DhhKnowItems = 'dhhKnowItems',
  EASEnabled = 'easEnabled',
}
